import axios from 'axios';
import { SetStateAction } from 'react';
import { Dispatch } from 'redux';
import { CHARGE_USER_FAILURE, CHARGE_USER_REQUEST, CHARGE_USER_SUCCESS, CLEAR_CHARGED_USER_DATA } from '../constants/chargeUser.constants';

const chargeUserRequest = () => {
    return {
        type: CHARGE_USER_REQUEST,
    };
};

const chargeUserSuccess = (data: any) => {
    return {
        type: CHARGE_USER_SUCCESS,
        payload: data,
    };
};

const chargeUserError = (error: any) => {
    return {
        type: CHARGE_USER_FAILURE,
        payload: error,
    };
};

export const chargeUser = (chargeUserObj: any, setShowChargeModal: React.Dispatch<SetStateAction<boolean>>) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(chargeUserRequest());
        return await axios
            .post('/transactions/admin-charge', chargeUserObj)
            .then((response) => {
                dispatch(chargeUserSuccess(response.data));
                setShowChargeModal(false);
            })
            .catch((error) => {
                dispatch(chargeUserError(error.response.data.message));
                setShowChargeModal(false);
            });
    };
};

export const clearChargedUserData = () => {
    return {
        type: CLEAR_CHARGED_USER_DATA,
    };
};

export const clearPreviosChargedUserData = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch(clearChargedUserData());
    };
};
